module.exports = __webpack_public_path__ + "static/media/XLS.8fa707de.svg";